export type TelemetryRuntimeMode = "client" | "server";
export type TelemetryRuntimeInput = TelemetryRuntimeMode | "auto";

export function isBrowserEnvironment(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function isNodeEnvironment(): boolean {
  return (
    typeof process !== "undefined" &&
    Boolean(process.versions?.node) &&
    !isBrowserEnvironment()
  );
}

/** Detect client vs server (SSR, Node loaders, Nitro, etc.) */
export function detectRuntime(): TelemetryRuntimeMode {
  if (isBrowserEnvironment()) return "client";

  if (isNodeEnvironment()) return "server";

  // Edge / unknown: treat as server when no window
  return "server";
}

export function resolveRuntime(input: TelemetryRuntimeInput = "auto"): TelemetryRuntimeMode {
  if (input === "auto") return detectRuntime();
  return input;
}

export function isClientRuntime(runtime: TelemetryRuntimeMode): boolean {
  return runtime === "client";
}

export function isServerRuntime(runtime: TelemetryRuntimeMode): boolean {
  return runtime === "server";
}
